export default class Tax {
  /** @type {string?} */ taxType = null
  /** @type {number?} */ taxRate = null
  /** @type {number?} */ cuota = null
  /** @type {number?} */ equivalenceSurcharge = null
}
